import TooltipBase from 'components/common/TooltipBase/TooltipBase';
import style from './AppMenu.module.scss';

const AppMenu = () => {
  return (
    <ul className={style.menu}>
      <li>
        <button type="button" className={`${style.menu_btn} ${style['menu_btn-active']}`}>
          Soneva
        </button>
      </li>
      <li>
        <button type="button" className={`${style.menu_btn}`} disabled>
          Petra
        </button>

        <TooltipBase className={style.tooltip}>Hamarosan</TooltipBase>
      </li>
      <li>
        <button type="button" className={`${style.menu_btn}`} disabled>
          Caesar
        </button>

        <TooltipBase className={style.tooltip}>Hamarosan</TooltipBase>
      </li>
    </ul>
  );
};

export default AppMenu;
